import { Cookies } from 'react-cookie';

import { CreatedVsFixedPerMonthChartData } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getCreateVsFixEncPerMonthChart = async (slug: string, start_date: string, end_date: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/encounters/charts/create_and_fix_encounters_per_month/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_date,
      end_date,
    },
  });

  return data.data as CreatedVsFixedPerMonthChartData;
};
